
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexcs7MsJgPzV5BgCpdjY5ojTOHENnjSlag7IZL5GA62TQMeta } from "/unified-client/pages/index.vue?macro=true";
import { default as _91id_93IV7J0jWbqxKGPc0pkf3HKi6GNzpM96zGqJNoi4wZKIsMeta } from "/unified-client/pages/alerts/[id].vue?macro=true";
import { default as index8ykuQQ7PcuFj86U7bg0pKbYvn2YlLSMsea5bh_45oTFt0Meta } from "/unified-client/pages/logIn/index.vue?macro=true";
import { default as _91id_93ZqrD3TSvlPz1a4a4L5_451uTbLEPZY2pmVnsNvoBvFHcAMeta } from "/unified-client/pages/manage/[id].vue?macro=true";
import { default as indexO3v5JN_4549d3BSadWltWhNHINrTjM9JSruJY_7WW5eGgMeta } from "/unified-client/pages/charts/index.vue?macro=true";
import { default as indexihHqko7mB1qmpUFokGDNRDdp0UsJtiatQy5jGmGM_45BQMeta } from "/unified-client/pages/logout/index.vue?macro=true";
import { default as indexe27d_45towOTrvUvWcwvSV_45_weG4WIZLdlNv30ByDUMCkMeta } from "/unified-client/pages/manage/index.vue?macro=true";
import { default as indexTUKrEVv_45yWQ5Z0T_I_45pQAL6GbGULJojl4F4JLxCelnMMeta } from "/unified-client/pages/search/index.vue?macro=true";
import { default as index5JtswjhhL1mwrpPsc8iH0hkSFDcsS3zzf8ldLpqV_45MoMeta } from "/unified-client/pages/social/index.vue?macro=true";
import { default as index7J4GKIwSlTzsK_IFsat_HIl4ag6286eNvU50H5ekMXQMeta } from "/unified-client/pages/topics/index.vue?macro=true";
import { default as indexbmmnwb7CQ3lSEWsDAtyivdyU29bxEnHt_45PLBgRa8M1YMeta } from "/unified-client/pages/expired/index.vue?macro=true";
import { default as index7Op3H6g4e1gRebRBYKh3rXQN453rK_45buv1RZQAjzhAQMeta } from "/unified-client/pages/explore/index.vue?macro=true";
import { default as indexpTcBET3v5b4faj3PfJew29F6RCWymlzlss_yLStySrkMeta } from "/unified-client/pages/reports/index.vue?macro=true";
import { default as indexFFdBSKqF2eiXshXvY3w5AO0HUkwo7Ck_EJpU6hvnjuEMeta } from "/unified-client/pages/mentions/index.vue?macro=true";
import { default as indexrmyZIKfGEOQWyvl_r2V84H50EISmiV6KXmin7X5d_iMMeta } from "/unified-client/pages/settings/index.vue?macro=true";
import { default as mentionzoSiUnr0rMyqEhikVeptbyKfuiNypo2u05NlJxutecIMeta } from "/unified-client/pages/upsell/mention.vue?macro=true";
import { default as indexvLivjwY2C2ewexY1qbEkjfOZ3_454s4_456Mj9mI7Xnoi24Meta } from "/unified-client/pages/no-access/index.vue?macro=true";
import { default as indexABXwy5_GHPn75xILzAPGmnScbdjSimffvQd6PJxoW9gMeta } from "/unified-client/pages/ppt-reports/index.vue?macro=true";
import { default as indexWgEDjJdTM_45hvzYDVD6TLVjc1lDgCh9tVeAwtX0Zt1nMMeta } from "/unified-client/pages/password/edit/index.vue?macro=true";
import { default as indexYNWi2c2TzrOnbDlsrNNt0svdiXUe_NOIR3h_7__NOxoMeta } from "/unified-client/pages/purchased-content/index.vue?macro=true";
import { default as indexcbHt72ZpSpwWkOpWCX58uog9dt4g5iIeRIiVgROP8g4Meta } from "/unified-client/pages/fetch-email-digest/index.vue?macro=true";
import { default as indexvzH2fKKLAy41P7F3E06hz1_451f4qiiiyPdIgklyf7gbQMeta } from "/unified-client/pages/target-media-lists/index.vue?macro=true";
import { default as indexzeSCFrKiCjy6dfrg3bDXYZtdE_a0YLAPTEYlAgtXpMgMeta } from "/unified-client/pages/fetch-article-alert/index.vue?macro=true";
import { default as indexoDNQt_SdQVZb8elMnCxG3RmE7aZPDermbqOGd3zLGhwMeta } from "/unified-client/pages/social/accounts/callback/index.vue?macro=true";
import { default as indext_E_45TRMe_u291pEblgeFbOJDdcVsZ6fQqhfaod4Gs3AMeta } from "/unified-client/pages/unified-frontend-playground/index.vue?macro=true";
import { default as unified_45tab_45panelGnSy3H9d92EXxqMaImR8p7RkkJTWj9U4HDfE1WYZKu4Meta } from "/unified-client/pages/unified-frontend-playground/unified-tab-panel.vue?macro=true";
import { default as unified_45pdf_45viewerAslFqTX0BwvAIhqv5fRXZx6NHiLN3Vm1BnsJ4qF6EP4Meta } from "/unified-client/pages/unified-frontend-playground/unified-pdf-viewer.vue?macro=true";
import { default as unified_45article_45bodyDAnBwJTFaElpP_45YDYOAOngaChkQhoFaG9LrFcNo8QmUMeta } from "/unified-client/pages/unified-frontend-playground/unified-article-body.vue?macro=true";
import { default as unified_45panel_45headert4OwK1TniOPBUGtXoh9Ke48j8ChLxofArKJTVeLQlMkMeta } from "/unified-client/pages/unified-frontend-playground/unified-panel-header.vue?macro=true";
import { default as unified_45article_45header_457mXE7DKmUsDzw0bulLB6IGhxDDeAG7wqY_45LjCUD8tgMeta } from "/unified-client/pages/unified-frontend-playground/unified-article-header.vue?macro=true";
import { default as unified_45full_45text_45contentdhYCp8Nq35_45Tdw81aYtSuHHCCx00ZxMRCmYS_45lyJZgUMeta } from "/unified-client/pages/unified-frontend-playground/unified-full-text-content.vue?macro=true";
import { default as unified_45full_45text_45dividerSBaCzpzv43rwEy9LkhgzsK_45iKzRz_dL7MoFnvkOoxzEMeta } from "/unified-client/pages/unified-frontend-playground/unified-full-text-divider.vue?macro=true";
import { default as unified_45view_45content_45panelJgHppjzbta_TtIpgV6gbN78hQfxfMJeftSuXSFENGikMeta } from "/unified-client/pages/unified-frontend-playground/unified-view-content-panel.vue?macro=true";
import { default as unified_45compact_45close_45buttonIZqBDDVyCdldwo4KI8_tutBxTrPKhh5bD9DltvNRfyAMeta } from "/unified-client/pages/unified-frontend-playground/unified-compact-close-button.vue?macro=true";
import { default as unified_45go_45to_45mention_45buttonjaEV_v8rA5BPYVzzxkgIhWPauigs68qxETZ7pLVKIngMeta } from "/unified-client/pages/unified-frontend-playground/unified-go-to-mention-button.vue?macro=true";
import { default as unified_45view_45content_45tab_45barGc9Vo31okXt3dNvX0_45waGImOxT1dbffNHoH7zLxI_LIMeta } from "/unified-client/pages/unified-frontend-playground/unified-view-content-tab-bar.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/unified-client/pages/index.vue")
  },
  {
    name: "alerts-id",
    path: "/alerts/:id()",
    component: () => import("/unified-client/pages/alerts/[id].vue")
  },
  {
    name: "logIn",
    path: "/logIn",
    component: () => import("/unified-client/pages/logIn/index.vue")
  },
  {
    name: "manage-id",
    path: "/manage/:id()",
    component: () => import("/unified-client/pages/manage/[id].vue")
  },
  {
    name: "charts",
    path: "/charts",
    component: () => import("/unified-client/pages/charts/index.vue")
  },
  {
    name: "logout",
    path: "/logout",
    component: () => import("/unified-client/pages/logout/index.vue")
  },
  {
    name: "manage",
    path: "/manage",
    component: () => import("/unified-client/pages/manage/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/unified-client/pages/search/index.vue")
  },
  {
    name: "social",
    path: "/social",
    meta: index5JtswjhhL1mwrpPsc8iH0hkSFDcsS3zzf8ldLpqV_45MoMeta || {},
    component: () => import("/unified-client/pages/social/index.vue")
  },
  {
    name: "topics",
    path: "/topics",
    component: () => import("/unified-client/pages/topics/index.vue")
  },
  {
    name: "expired",
    path: "/expired",
    component: () => import("/unified-client/pages/expired/index.vue")
  },
  {
    name: "explore",
    path: "/explore",
    component: () => import("/unified-client/pages/explore/index.vue")
  },
  {
    name: "reports",
    path: "/reports",
    component: () => import("/unified-client/pages/reports/index.vue")
  },
  {
    name: "mentions",
    path: "/mentions",
    component: () => import("/unified-client/pages/mentions/index.vue")
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/unified-client/pages/settings/index.vue")
  },
  {
    name: "upsell-mention",
    path: "/upsell/mention",
    component: () => import("/unified-client/pages/upsell/mention.vue")
  },
  {
    name: "no-access",
    path: "/no-access",
    component: () => import("/unified-client/pages/no-access/index.vue")
  },
  {
    name: "ppt-reports",
    path: "/ppt-reports",
    component: () => import("/unified-client/pages/ppt-reports/index.vue")
  },
  {
    name: "password-edit",
    path: "/password/edit",
    component: () => import("/unified-client/pages/password/edit/index.vue")
  },
  {
    name: "purchased-content",
    path: "/purchased-content",
    component: () => import("/unified-client/pages/purchased-content/index.vue")
  },
  {
    name: "fetch-email-digest",
    path: "/fetch-email-digest",
    component: () => import("/unified-client/pages/fetch-email-digest/index.vue")
  },
  {
    name: "target-media-lists",
    path: "/target-media-lists",
    component: () => import("/unified-client/pages/target-media-lists/index.vue")
  },
  {
    name: "fetch-article-alert",
    path: "/fetch-article-alert",
    component: () => import("/unified-client/pages/fetch-article-alert/index.vue")
  },
  {
    name: "social-accounts-callback",
    path: "/social/accounts/callback",
    component: () => import("/unified-client/pages/social/accounts/callback/index.vue")
  },
  {
    name: "unified-frontend-playground",
    path: "/unified-frontend-playground",
    component: () => import("/unified-client/pages/unified-frontend-playground/index.vue")
  },
  {
    name: "unified-frontend-playground-unified-tab-panel",
    path: "/unified-frontend-playground/unified-tab-panel",
    component: () => import("/unified-client/pages/unified-frontend-playground/unified-tab-panel.vue")
  },
  {
    name: "unified-frontend-playground-unified-pdf-viewer",
    path: "/unified-frontend-playground/unified-pdf-viewer",
    component: () => import("/unified-client/pages/unified-frontend-playground/unified-pdf-viewer.vue")
  },
  {
    name: "unified-frontend-playground-unified-article-body",
    path: "/unified-frontend-playground/unified-article-body",
    component: () => import("/unified-client/pages/unified-frontend-playground/unified-article-body.vue")
  },
  {
    name: "unified-frontend-playground-unified-panel-header",
    path: "/unified-frontend-playground/unified-panel-header",
    component: () => import("/unified-client/pages/unified-frontend-playground/unified-panel-header.vue")
  },
  {
    name: "unified-frontend-playground-unified-article-header",
    path: "/unified-frontend-playground/unified-article-header",
    component: () => import("/unified-client/pages/unified-frontend-playground/unified-article-header.vue")
  },
  {
    name: "unified-frontend-playground-unified-full-text-content",
    path: "/unified-frontend-playground/unified-full-text-content",
    component: () => import("/unified-client/pages/unified-frontend-playground/unified-full-text-content.vue")
  },
  {
    name: "unified-frontend-playground-unified-full-text-divider",
    path: "/unified-frontend-playground/unified-full-text-divider",
    component: () => import("/unified-client/pages/unified-frontend-playground/unified-full-text-divider.vue")
  },
  {
    name: "unified-frontend-playground-unified-view-content-panel",
    path: "/unified-frontend-playground/unified-view-content-panel",
    component: () => import("/unified-client/pages/unified-frontend-playground/unified-view-content-panel.vue")
  },
  {
    name: "unified-frontend-playground-unified-compact-close-button",
    path: "/unified-frontend-playground/unified-compact-close-button",
    component: () => import("/unified-client/pages/unified-frontend-playground/unified-compact-close-button.vue")
  },
  {
    name: "unified-frontend-playground-unified-go-to-mention-button",
    path: "/unified-frontend-playground/unified-go-to-mention-button",
    component: () => import("/unified-client/pages/unified-frontend-playground/unified-go-to-mention-button.vue")
  },
  {
    name: "unified-frontend-playground-unified-view-content-tab-bar",
    path: "/unified-frontend-playground/unified-view-content-tab-bar",
    component: () => import("/unified-client/pages/unified-frontend-playground/unified-view-content-tab-bar.vue")
  }
]